import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiRestService } from '../../services/NXI-Rest.service';

declare let dojoApp: any;

@Component({
    selector: 'dojo-historic-rgl-filter',
    templateUrl: './dojo-historic-rgl-filter.component.html'
})
export class DojoHistoricRGLFilterComponent implements OnInit, AfterViewInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    storeUrl: any;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService) {
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getHistoricActivityFilter();
        });
    }

    renderDojoWidget(): void {
        if (dojoApp) {
            dojoApp.historicRGLFilter();
            this.storeUrl = this.nxiRestService.serviceUrl + '/portfolio/'  + this.acctRef + '/rgl/summary/historicData';
            dojoApp.historicRGLSummary(this.storeUrl);
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('historySummary');
        }
    }

    getHistoricActivityFilter() {
        if (this.acctRef) {
            this.renderDojoWidget();
        }
    }

}
